// @i18n-ignore-file
/**
 * Common storage constants used across different storage utilities
 * (localStorage, sessionStorage, cookies)
 */

export const STORAGE_PREFIX = 'q'
export const GLOBAL_PREFIX = 'global'

// Check if i18n is enabled from environment variable
export const IS_I18N_ENABLED = process.env.NEXT_PUBLIC_ENABLE_I18N === 'true'
